import { render, staticRenderFns } from "./LoadingFailedCard.vue?vue&type=template&id=ecdeda7a&scoped=true&lang=pug"
import script from "./LoadingFailedCard.vue?vue&type=script&lang=js"
export * from "./LoadingFailedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdeda7a",
  null
  
)

export default component.exports